$('document').ready(function () {

    if (document.getElementById('employer')) {

        $('.item-project').on('hide.bs.collapse', function () {
            $(this).find(".full-details").html("...");
            $(this).find(".cut-description").removeClass("hidden");
            $(this).find(".cut-allDescription").addClass("hidden");
        }).on("show.bs.collapse", function () {
            $(this).find(".full-details").html("Hide");
            $(this).find(".cut-description").addClass("hidden");
            $(this).find(".cut-allDescription").removeClass("hidden");

        });

        function cleanResults(){
            $(".onchange").change(function() {
                $(".results_box_people").html("");
            });
        }

        $('#sort_switcher').change(function () {
            $('.sort-box').hide();
            var sortType = $(this).val();
            if (sortType) {
                    $('#' + sortType).show();
            }
        });

        if (document.getElementById('not_pr_page')) {

$(".closePr").click(function () {

    var data = {
        project_id: $(this).attr("data-id")
    };

    $.when(postRequest(data, "/api/project/close"))
        .done(function (answer) {
                if (answer == "success") {
                    window.location.replace("/profile/projects");
                }
            }
        );
})



        }


function addBtnAction() {
    $("#employer .person .full-details").click(function () {
        var id = $(this).attr('data-target');

        if ($(this).hasClass('in')) {
            $(id).hide();
            $(this).html("...");
            $(this).removeClass('in');
        } else {
            $(id).css('display', 'inline-block');
            $(this).html("hide");
            $(this).addClass('in');
        }
    });
}
        addBtnAction();
        // =============================filters=======================
        if ($("#profile").hasClass("search_page")) {

            $(".search-box .first-inp").select2({
                placeholder: 'SAP Module',
            });

            $('#sap_skills_2').select2({
                placeholder: 'SAP skills',
            });

            $(".search-box .level").select2({
                placeholder: 'Level',
            });

            $(".search-box .cities").select2({
                placeholder: 'City',
            });

            $(".search-box .search-type").select2({
                minimumResultsForSearch: -1
            });


            var skills_edit = $(".second-inp").val();
            var sap_module = $("#sap_skills").val();
            function eventOnSearchBySkills(data, tab) {
                var options1 = [];
                var options2 = {};
                data.sort(function(a, b){
                    return b["name"] < a["name"] ? 1 : -1;
                });
                data.forEach(function (item, i) {
                    var option1;
                    option1 = new Option(item['name'], item['id']);
                    options2[item['id']] = [];

                    item["parameters"].forEach(function (item2, j) {
                        var option2 = [];
                        if (item2["name"] != "Other") {
                            option2 = new Option(item2['name'], item2['id']);
                            options2[item['id']].push(option2);
                        }
                    })
                    options1.push(option1);
                });
                options1.sort(function(a, b){
                    return b["label"] < a["label"] ? 1 : -1;
                });
                $(tab + " .first-inp").html("").append(options1);

                $('#sap_skills').val(sap_module).trigger('change');

                // ==================if edit=========
                var sap_skills_edit = $("#sap_skills").val();

                var options = [];
                if (sap_skills_edit) {
                    sap_skills_edit.forEach(function (item, i) {
                        options = options.concat(options2[item]);
                    });
                }

                options.sort(function(a, b){
                    return b["label"] < a["label"] ? 1 : -1;
                });
                $(tab + " .second-inp").html("").append(options);

                $('#sap_skills_2').val(skills_edit).trigger('change');
                // ===========================


                $(tab + "  .first-inp").on("change", function () {
                    var firstVal = $(this).val();

                    var options = [];
                    if (firstVal) {
                        firstVal.forEach(function (item, i) {

                            options = options.concat(options2[item]);

                        });
                    }
                    options.sort(function(a, b){
                        return b["label"] < a["label"] ? 1 : -1;
                    });
                    $(tab + " .second-inp").html("").append(options);
                });
                cleanResults();
            }

            var category = {data: ["SAP"]};


            $.when(postRequest(category, "/api/get/skills/all"))
                .done(function (answer) {

                        var data = answer[0]['category_type'];
                        eventOnSearchBySkills(data, ".search-box");
                    }
                );
            $("#search-people").click(function (e) {
                var data = $("form.search-box").serializeArray();

                var dataF  = data.filter(function (el) {
                    return el != null;
                });

                var pr_id = $(this).attr("data-pr-id");

                $.when(postRequest(dataF, "/people/filter"))
                    .done(function (answer) {
                            var newData = answer.data;
                            if (newData.length) {
                                rendersPeopleForSearch(newData, pr_id);

                            } else {
                                $(".results_box_people").html("<h4>No one found yet - relax your search criteria a little and try again.</h4>")
                            }
                            addPaginator(answer.global_count, $(".pagination"));
                        }
                    );
            });
        }


        function rendersPeopleForSearch(arrData, id) {
            var noData = "not_indicated";
            var data = [];
            for (var i = 0; i < arrData.length; i++) {
                var target_base_range, target_daily_rate, min_daily_rate, max_daily_rate,landed_rate_min,landed_rate_max,twitter,linkedin,twitterCl,linkedinCl,twitterActive,linkedinActive;

                if(arrData[i].user.twitter==""){
                    twitterActive="not_indicated";
                }else{
                    var check = arrData[i].user.twitter.indexOf("https://");
                    var check2 = arrData[i].user.twitter.indexOf("http://");
                    if(check==-1 && check2==-1){
                        twitter= "https://"+ arrData[i].user.twitter;
                    }else{
                        twitter= arrData[i].user.twitter;
                    }
                    twitterCl="chosen";
                }

                if(arrData[i].user.linkedin==""){
                    linkedinActive="not_indicated";
                }else{
                    var check = arrData[i].user.linkedin.indexOf("https://");
                    var check2 = arrData[i].user.linkedin.indexOf("http://");
                    if(check==-1 && check2==-1){
                        linkedin= "https://"+ arrData[i].user.linkedin;
                    }else {
                        linkedin = arrData[i].user.linkedin;
                    }
                    linkedinCl="chosen";
                }


                if(arrData[i].candidate.display_rate == 1){
                    if (typeof arrData[i].target_base_range!="string") {
                        target_base_range = arrData[i].target_base_range.value;
                    } else {
                        target_base_range = arrData[i].target_base_range;
                        if(target_base_range=="not indicated" || target_base_range==""){
                            target_base_range=noData;
                        }
                    }

                    if (typeof arrData[i].target_daily_rate != "string") {
                        target_daily_rate = [];
                        target_daily_rate = arrData[i].target_daily_rate.value;
                    } else {
                        target_daily_rate = arrData[i].target_daily_rate;
                        if(target_daily_rate=="not indicated" || target_daily_rate==""){
                            target_daily_rate=noData;
                        }
                        min_daily_rate = "not";
                        max_daily_rate = "not"
                    }


                    landed_rate_max = arrData[i].max_landed_rate;
                    if(landed_rate_max=="not indicated" || landed_rate_max=="" || landed_rate_max=="0" || landed_rate_max==0){
                        landed_rate_max=noData;
                    }

                    landed_rate_min = arrData[i].min_landed_rate;
                    if(landed_rate_min=="not indicated" || landed_rate_min==""|| landed_rate_min=="0" || landed_rate_min==0){
                        landed_rate_min=noData;
                    }
                }else{
                    target_base_range=noData;
                    target_daily_rate=noData;
                    landed_rate_max=noData;
                    landed_rate_min=noData;
                }

                var  rating="";
                var gray="<div><img src='/img/ico-rating_02.png'></div>";
                var green="<div><img src='/img/ico-rating_01.png'></div>";
                 if(arrData[i].rating<=10){
                    for(var k=0;k<arrData[i].rating;k++){
                        rating += green;
                    }
                     for(var k=arrData[i].rating;k<10;k++){
                         rating += gray;
                     }
                 }
                 else {
                     rating += "<div><img src='/img/ico-rating_03.png'> </div>";
                 }


                data[i] = {

                    SummaryFirst: arrData[i].candidate.summary !== "" ? arrData[i].candidate.summary.slice(0, 200) : noData,
                    SummarysScond: arrData[i].candidate.summary !== "" ? arrData[i].candidate.summary.slice(200) : noData,
                    SummarysDtn: (arrData[i].candidate.summary !== "" && arrData[i].candidate.summary.slice(200))?"" : noData,
                    twitter:twitter,
                    linkedin:linkedin,
                    twitterCl:twitterCl,
                    linkedinCl:linkedinCl,
                    twitterActive:twitterActive,
                    linkedinActive:linkedinActive,
                    rating:rating,
                    city:arrData[i].city.length?arrData[i].city.join(', '):noData,
                    country:arrData[i].country? arrData[i].country:noData,
                    landed_rate_min:landed_rate_min,
                    landed_rate_max:landed_rate_max,
                    logo: "/" + arrData[i].user.img_src,
                    name: arrData[i].user.first_name + " " + arrData[i].user.last_name,
                    position: arrData[i].user.position != "" ? arrData[i].user.position:noData,
                    level: arrData[i].position_skills.join(', ') !== "" ? arrData[i].position_skills.join(', ') : "not_indicated",
                    sapSkills: arrData[i].sap_skills.join(', '),
                    summary: arrData[i].candidate.summary,
                    userId: arrData[i].candidate.id,
                    projectId: id,
                    date: JSON.stringify(arrData[i].dates),
                    budgetMin: arrData[i].candidate.landed_rate_min,
                    budgetMax: arrData[i].candidate.landed_rate_max,
                    cv: arrData[i].candidate.cv_file ? arrData[i].candidate.cv_file : "not-active",
                    candidateName: arrData[i].user.first_name,
                    candidateEmail: arrData[i].user.email,
                    candidatePhone: arrData[i].user.phone_number,
                    is_contact_view: +arrData[i].is_contact_view ? 1 : 0,
                    contactTitle: +arrData[i].is_contact_view ? "Contact Details Viewed" : "Contact",
                    target_base_range: target_base_range,
                    target_daily_rate: target_daily_rate,
                    min_daily_rate: min_daily_rate,
                    max_daily_rate: max_daily_rate,
                    cvstyle: "v",
                    total_year_experience: arrData[i].total_year_experience ? arrData[i].total_year_experience : "not indicated"
                };
            }
            var info = transformData(data);
            $.when(renderMustache(info, $(".results_box_people"), "/templates/profile/candidate.html", $(".results_box_people"), '#person')).done(function (answer) {
                if (answer) {
                    init();
                    addBtnAction();
                    var ratings = $(".bl-rating.description");
                    for(var k=0; k<ratings.length; k++){
                        $(ratings[k]).html($(ratings[k]).attr("data-rating"))
                    }
                    addEventOnCalendar();
                    addCandEvent($("#profile .results_box_people .column-status"));
                }
            });

        }

        function renderMustache(info, conLoad, file, contOnPage, id) {
            var deferred = $.Deferred();
            conLoad.load(file + id + '', function () {
                var template = $(id).html();
                var substr = "data-src";
                template = template.replace(new RegExp(substr, 'g'), "src");
                var output = Mustache.render(template, info);
                contOnPage.html(output);
                deferred.resolve(true);
            });
            return deferred.promise();
        }

        function transformData(data) {
            return {
                data: data.map(function (data) {
                    return data
                })
            }
        }

        // =============================================================


        function forClousingPr(id, self) {
            self.find(".prod-status img").attr("src", "/img/icons_svg/ico-applied-not.svg");
            self.find(".prod-status span").html("Project Closed");
            self.find(".closePr").addClass("reOpen").find("img").attr("src", "/img/icons_svg/refresh-gray.svg");
            self.find(".closePr").toggleClass("closePr");
            self.find(".reOpen span").html("Closed: Re-open Project");
            self.find("a.find_people").addClass("no_cursor");
            self.find("a.applicants").addClass("no_cursor");
            self.find("a.shortlist").addClass("no_cursor");

            $(".employers_project .person").html("");
            var pr = $('#active-projects #item-project-' + id).clone();
            $("#closed-projects .employers_project").append(pr);
            $.when($('#item-project-' + id).fadeOut("slow"))
                .done(function () {
                    $('#active-projects #item-project-' + id).remove();
                });

            addPrEvent($("#profile.employer #item-project-" + id + " .column-status"));
        }

        function forReopeningPr(id, self) {
            $(".employers_project .person").html("");
            self.find(".prod-status img").attr("src", "/img/icons_svg/ico-applied-yes.svg");
            self.find(".prod-status span").html("Project Open");
            self.find(".reOpen").addClass("closePr").find("img").attr("src", "/img/icons_svg/refresh-closePr.svg");
            self.find(".reOpen").toggleClass("reOpen");
            self.find(".closePr span").html("Close Project");
            self.find("a.find_people").removeClass("no_cursor");
            self.find("a.applicants").removeClass("no_cursor");
            self.find("a.shortlist").removeClass("no_cursor");

            var pr = $('#closed-projects #item-project-' + id).clone();
            $("#active-projects .employers_project").append(pr);
            $.when($('#closed-projects #item-project-' + id).fadeOut("slow"))
                .done(function () {
                    $('#closed-projects #item-project-' + id).remove();
                });

            addPrEvent($("#profile.employer #item-project-" + id + " .column-status"));
        }

        function addPrEvent(tag) {

            tag.click(function (e) {
                    var self = $(this);
                    var target = $(e.target);
                    var action;
                    var classes = target.attr("class") + "";
                    classes += target.parent().attr("class");

                    if (classes.indexOf("no_evetnt") >= 0) {
                        return 0;
                    }


                    var prActions = [
                        {
                            name: "closePr",
                            feedback: forClousingPr,
                            route: "/api/project/close"
                        },
                        {
                            name: "reOpen",
                            feedback: forReopeningPr,
                            route: "/api/project/reopen"
                        }
                    ];

                    for (i = 0; i < prActions.length; i++) {

                        if (classes.indexOf(prActions[i]['name']) >= 0) {
                            action = prActions[i];
                        }

                    }

                    if (target.parents("." + action["name"]).size() || target.hasClass("." + action["name"])) {
                        var data;


                        if (+target.parents("." + action["name"]).size()) {
                            data = {
                                project_id: target.parent("." + action["name"]).attr("data-id")
                            };

                        } else {
                            data = {
                                project_id: target.attr("data-id")
                            };
                        }
                        $.when(postRequest(data, action["route"]))
                            .done(function (answer) {
                                    if (answer == "success") {
                                        action["feedback"](data.project_id, self);
                                    }
                                }
                            );

                    }

                }
            );
        }

        function addCantToSortlist(answer, self) {
            if (answer == "true" || +answer == 1) {
                self.find(".shortlist span").html("Shortlisted");
                var src = self.find(".shortlist img").attr("src");
                var num = parseInt(src.replace(/\D+/g, ""));
                self.find(".shortlist img").attr("src", src.replace(new RegExp(num, 'g'), answer));

                var projList = $("#employer .item-project .column-status .shortlist");
             
                projList.find("span").html("View Shortlist");
                projList.find("img").attr("src", src.replace(new RegExp(num, 'g'), answer));

            } else if (answer == "false" || +answer == 0) {
                self.find(".shortlist span").html("Add to Shortlist");
                var src = self.find(".shortlist img").attr("src");
                var num = parseInt(src.replace(/\D+/g, ""));
                self.find(".shortlist img").attr("src", src.replace(new RegExp(num, 'g'), answer));
            }
        }

        function declineCant(answer, self) {

            self.find(".shortlist img").attr("src", "/img/icons_svg/shortlisted-0.svg");
            self.find(".shortlist span").html("Add to Shortlist");
            self.find(".decline img").attr("src", "/img/icons_svg/ico-decline-1.svg");
            self.find(".decline span").html("Declined");
            self.find("a.decline").addClass("no_cursor");
            self.find(".engaged img").attr("src", "/img/icons_svg/ico-engaged-0.svg");
            self.find(".engaged span").html("Declined")
        }

        function seeContact(answer, self) {
            if (answer == "true" || +answer == 1) {
                self.find(".phone img").attr("src", "/img/icons_svg/telephone-1.svg");
                self.find(".phone span").html("Contact Details Viewed");
            }
            // else if (answer == "false" || +answer == 0) {
            //     self.find(".phone img").attr("src", "/img/icons_svg/telephone-0.svg");
            //     self.find(".phone span").html("Contact");
            // }
        }

        function offerToCand(answer, self) {
            if (+answer) {

                if(self.find("a.engaged").attr('data-text')=="Engagement Offered"){
                    self.find(".engaged span").html("Engagement Offered");
                } else {
                    self.find(".engaged span").html("Invited to project");
                }
                self.find(".engaged img").attr("src", "/img/icons_svg/ico-engaged-1.svg");
                self.find("a.engaged").addClass("no_cursor");
            }
        }

        $("#engageTemlp").on('hide.bs.modal', function(){
            $(".engagePerson").off('click');
        });
        $("#afterAcceptance").on('hide.bs.modal', function(){
            $(".engagePerson").off('click');
        });
        $("#declineTemp").on('hide.bs.modal', function(){
            $(".engagePerson").off('click');
        });

        function addCandEvent(tag) {
            tag.click(function (e) {
                    var self = $(this);
                    var target = $(e.target);
                    var action;
                    var classes = target.attr("class") + "";
                    classes += target.parent().attr("class");
                    var candActions = [
                        {
                            name: "shortlist",
                            feedback: addCantToSortlist,
                            route: "/api/project/shortlisted"
                        },
                        {
                            name: "decline",
                            feedback: declineCant,
                            route: "/api/project/decline"
                        },
                        {
                            name: "phone",
                            feedback: seeContact,
                            route: "/api/project/show/contact"
                        },
                        {
                            name: "engaged",
                            feedback: offerToCand,
                            route: "/api/project/hire"
                        }
                    ];

                    for (i = 0; i < candActions.length; i++) {
                        if (classes.indexOf(candActions[i]['name']) >= 0) {
                            action = candActions[i];
                        }
                    }

                    if (action["name"] == "engaged" && self.find(".engaged").hasClass("disabled")) {
                        return 0
                    }

                    if (target.parents("." + action["name"]).size() || target.hasClass("." + action["name"])) {
                        var data;


                        if (+target.parents("." + action["name"]).size()) {
                            data = {
                                project_id: target.parent("." + action["name"]).attr("data-proj-id"),
                                candidate_id: target.parent("." + action["name"]).attr("data-user-id")
                            };

                        } else {
                            data = {
                                project_id: target.attr("data-proj-id"),
                                candidate_id: target.attr("data-user-id")
                            };
                        }
                        console.log(action["name"])
                        if (action["name"] != "engaged" && action["name"] != "decline" ){
                        $.when(postRequest(data, action["route"]))
                            .done(function (answer) {
                                    if (action["name"] == "shortlist" || "phone" || "decline" || "engaged") {
                                        action["feedback"](answer, self);
                                    }

                                }
                            );
                        } else {
                                $(".engagePerson").on("click",function () {
                                    if ( !$(this).hasClass("afterAcceptance") ) {
                                        if (action["name"] == "engaged"){
                                            $("#engageTemlp").modal('hide')
                                        }else{
                                            $("#declineTemp").modal('hide')
                                        }
                                    }

                                    $.when(postRequest(data, action["route"]))
                                        .done(function (answer) {
                                            if(answer==1 || answer==true){
                                                action["feedback"](answer, self);
                                            }});
                                })
                        }

                    }
                }
            )
        }

        addCandEvent($("#profile .results_box_people .column-status"));

        addPrEvent($("#profile.projects_page .column-status"));

// =================================
//         addPaginator($(".Profile-Employer #box-job .item-job"), $('.Profile-Employer #item-tab-3 .pagination'), "membership-", 20);
//         item, objPaginator, name, countPage
        //=======================pagination=======================

        function addFirstPaginator(objPaginator) {
            var numItems = $(".person").length;
            var perPage = 10;
            var displayedPages = 3;

            $(".results_box_people .person").slice(perPage).hide();
            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var showFrom = perPage * (pageNumber - 1);
                    var showTo = showFrom + perPage;
                    $(".person").hide().slice(showFrom, showTo).show();

                    $('html, body').animate({
                        scrollTop: $(".employers_project").offset().top
                    }, 2000);
                }
            });

            checkFragment(objPaginator, name);
        }

        addFirstPaginator($(".pagination"));

        function addPaginator(global_count, objPaginator) {

            var numItems = global_count;
            var perPage = 10;
            var displayedPages;
            if (numItems <= perPage) {
                displayedPages = 1;
            } else {
                displayedPages = 3;
            }

            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var pr_id = $("#search-people").attr("data-pr-id");
                    var offset = perPage * (pageNumber - 1);
                    var count;
                    if (pageNumber * perPage > numItems) {
                        count = numItems % perPage;
                    } else {
                        count = perPage;
                    }
                    var data = {
                        from_cache: "on",
                        count: count,
                        offset: offset
                    }
                    $.when(postRequest(data, "/people/filter"))
                        .done(function (answer) {
                                var newData = answer.data;
                                if (newData.length) {
                                    rendersPeopleForSearch(newData, pr_id);

                                    $('html, body').animate({
                                        scrollTop: $(".employers_project").offset().top
                                    }, 2000);

                                } else {
                                    $(".results_box_people").html("<h4>No one found yet - relax your search criteria a little and try again.</h4>")
                                }
                            }
                        );
                }
            });

            checkFragment(objPaginator, name);
        }

        function checkFragment(ob, name) {

            var hash = window.location.hash || name + "page-1";
            hash = hash.match(/^#cand-page-(\d+)$/);
            if (hash) {
                ob.pagination("selectPage", parseInt(hash[1]));
            }
        }

        $(window).bind("popstate", checkFragment);

        //=================request============================

        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

    }
});